<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/contact">联系我们</router-link>
    </div>
    <div class="top">
      <div class="top-left">
        <div class="top-left-item one">
          <span>联系方式 / </span>
          <span>contact information</span>
        </div>
        <div class="top-left-item">
          <span class="iconfont icon-dizhi" id="font"></span>
          <span>{{config.companyAddress}}</span>
        </div>
        <div class="top-left-item">
          <span class="iconfont icon-31dianhua" id="font"></span>
          <span>{{config.hotline}}</span>
        </div>
        <div class="top-left-item">
          <span class="iconfont icon-youxiang" id="font"></span>
          <span>{{config.mailbox}}</span>
        </div>
      </div>
      <div class="top-right">
        <img :src="config.contactUsUrl" alt="">
      </div>
    </div>
    <div class="amap">
      <el-amap class="amap-box" :zoom="zoom" :center="center" :vid="'amap-vue'">
        <el-amap-marker vid="marker" :position="center" :label="label">

        </el-amap-marker>
      </el-amap>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      center: [121.316584, 31.212878],
      zoom: 16,
      mapStyle: 'dark',
      label: {
        content: '上海盛目实业集团有限公司',
        offset: [20, 12]
      }
    }
  },
  computed: {
    ...mapGetters(['config'])
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  .breadcrumb {
    margin: 50px auto 50px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    &-left {
      width: 33%;
      &-item {
        padding: 15px 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        #font {
          display: inline-block;
          margin-right: 20px;
          font-size: 35px;
        }
        span:nth-last-of-type(1) {
          font-size: 16px;
          font-weight: 500;
        }
      }
      .one {
        color: #fff;
        font-weight: 700;
        display: block !important;
        background-color: #1c3c8a;
      }
    }
    &-right {
      width: 62%;
    }
  }
  .amap {
    height: 400px;
    margin-bottom: 60px;
  }
}
</style>
